export const drawerTabs: string[] = ["Edit Profile","My Sessions"];